import React from 'react';

function FormGroup(props) {
  return (
    <div className="form-group">
      { props.children }
    </div>
  )
}

export default FormGroup;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/FormGroup.jsx
 **/